import React from "react";

import { UserNavbar } from "@hl/shared-features/lib/features/auth/UserNavbar";
import { Navbar } from "@hl/shared-features/lib/features/layout/Navbar";
import useIsScrollTop from "@hl/shared-features/lib/hooks/useIsScrollTop";
import { Group, Header } from "@mantine/core";

import "@knocklabs/react/dist/index.css";

export const AppHeader = () => {
  const { isScrollTop } = useIsScrollTop();

  return (
    <Header
      height={56}
      pl="lg"
      pr="xs"
      withBorder={!isScrollTop}
      sx={{
        boxSizing: "content-box",
      }}
    >
      <Group w="100%" h="100%" position="apart" align="center">
        <Navbar>
          <UserNavbar />
        </Navbar>
      </Group>
    </Header>
  );
};
